import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
    title: String,
    button: boolean,
    buttonTitle: String,
    action: string,
}

function Header({title, button, buttonTitle, action}: Props) {
  return (
    <div className="w-11/12 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="h-7 w-1.5 rounded-full bg-accent" />
        <h1 className="font-display text-2xl font-bold tracking-tight text-ink">{title}</h1>
      </div>
      {button && (
        <Link to={action}>
          <button className="zbh-btn-accent">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            {buttonTitle}
          </button>
        </Link>
      )}
    </div>
  )
}

export default Header
